import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { FirmAddressJourney } from "@/features/firms/components/firm-address-journey"
import { describing } from "@/lib/subject"
import { firmRecordQueries } from "@/queries/firm-record"
import { firmQueries } from "@/queries/firms"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/addresses/edit/"
)({
  loader: async ({ context, params }) => {
    const [firm] = await Promise.all([
      context.queryClient.ensureQueryData(firmQueries.detail(params.firmId)),
      context.queryClient.ensureQueryData(
        firmRecordQueries.addresses(params.firmId)
      ),
    ])

    // Offered if the register answers, and skipped if it does not: a firm
    // whose address cannot be looked up is typed in, not held up.
    if (firm.companyNumber) {
      await context.queryClient
        .ensureQueryData(firmRecordQueries.registeredOffice(firm.companyNumber))
        .catch(() => undefined)
    }
  },
  component: UpdateFirmAddressesPage,
})

function UpdateFirmAddressesPage() {
  const { firmId } = Route.useParams()
  const navigate = useNavigate()
  const { data: firm } = useSuspenseQuery(firmQueries.detail(firmId))

  return (
    <FirmAddressJourney
      firmId={firmId}
      companyNumber={firm.companyNumber}
      subject={describing(firm.legalName)}
      onFinished={() =>
        navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId/addresses",
          params: { firmId },
        })
      }
    />
  )
}
